import * as React from 'react'
import { X } from 'lucide-react'

import { cn } from '@/core/lib/utils'

import { ModalOverlay } from './ModalOverlay'

export interface ModalProps {
  children: React.ReactNode
  open: boolean
  onClose: () => void
  className?: string
  showCloseButton?: boolean
}

export function Modal({
  children,
  open,
  onClose,
  className,
  showCloseButton = false,
}: ModalProps) {
  if (!open) {
    return null
  }

  return (
    <ModalOverlay onClose={onClose}>
      <div
        className={cn(
          'relative bg-white rounded-xl p-6 w-full max-w-lg',
          className
        )}
        role="dialog"
        aria-modal="true"
      >
        {showCloseButton && (
          <button
            type="button"
            onClick={onClose}
            className="absolute top-4 right-4 p-1 text-gray-400 hover:text-gray-600 rounded-full hover:bg-gray-100"
            aria-label="Close"
          >
            <X className="w-4 h-4" />
          </button>
        )}
        {children}
      </div>
    </ModalOverlay>
  )
}
